import React from 'react'
import { componentResolverFromMap } from 'gatsby-plugin-prismic-previews'
import { linkResolver } from './link_resolver'

export const prismicPreviewRepositoryConfigs = [
  {
    repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME || 'firststar-tech',
    linkResolver,
    componentResolver: componentResolverFromMap({
      blog: React.lazy(() => import('../templates/blog_post.js')),
      services: React.lazy(() => import('../templates/services.js')),
    }),
  },
]
